/**
 * Shared interfaces
 */

export interface GbPaginatedResponse<T> {
  count: number
  next: string | null
  previous: string | null
  results: T[]
}

export interface PasswordComplexityPolicyRegex {
  unit: number
  regex: string
}

export interface PasswordComplexityPolicy {
  min_length: PasswordComplexityPolicyRegex
  min_lowercase: PasswordComplexityPolicyRegex
  min_uppercase: PasswordComplexityPolicyRegex
  min_number: PasswordComplexityPolicyRegex
  min_special_chars: PasswordComplexityPolicyRegex
}

export interface GbGroupedEntities {
  key: string
  values: any[]
}

export enum FieldTypeEnum {
  Default = 'default',
  Text = 'text',
  Checkbox = 'checkbox',
  MultipleChoice = 'multiple_choice',
  Email = 'email',
}

export enum LockTypeEnum {
  Admin = 'admin',
  Locked = 'locked',
  Volunteer = 'volunteer',
  None = 'none',
}

export interface StringMap<T> {
  [key: string]: T
}

export enum VerifiedStateEnum {
  Unverified = 'unverified',
  Pending = 'pending',
  Verified = 'verified',
}
